const orderDetailsFormatter = (data) => {
  const dataSet = JSON.parse(JSON.stringify(data.data || data));
  dataSet["placeholder_name"] = dataSet.customer.name
  return dataSet
};

export default orderDetailsFormatter;
